import { caaMetricsRepositoryAdapter } from '../../infra/repositories/caaMetricsRepositoryAdapter'

export function GetPatientCAAMetricsWeekCase(
  repository: ReturnType<typeof caaMetricsRepositoryAdapter>
) {
  return async (params: {
    patientId: string
    personaName?: string
    date: string
  }) => {
    return await repository.getPatientCAAMetricsWeek(params)
  }
}
